import { render, staticRenderFns } from "./TaskEditor.vue?vue&type=template&id=74bd6ee4&scoped=true&"
import script from "./TaskEditor.vue?vue&type=script&lang=js&"
export * from "./TaskEditor.vue?vue&type=script&lang=js&"
import style0 from "./TaskEditor.vue?vue&type=style&index=0&id=74bd6ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bd6ee4",
  null
  
)

export default component.exports